// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.properties.RentalManagerUserPropertyArchiveV2WebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { RentalManagerUserPropertyArchiveV2WebApiHandler_archive } from '@zg-rentals/ts-rental-manager-api-client';

import type { UserPropertyArchiveV2RequestDto } from '@zg-rentals/ts-rental-manager-api-client';

export interface RentalManagerUserPropertyArchiveV2WebApiHandler_archive_Args {
  postData: UserPropertyArchiveV2RequestDto;
}

export type RentalManagerUserPropertyArchiveV2WebApiHandler_archive_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyArchiveV2WebApiHandler_archive_Args
>;

/**
 * Archive a listing and its dupes
 */
export const useRentalManagerUserPropertyArchiveV2WebApiHandler_archive = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyArchiveV2WebApiHandler_archive_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyArchiveV2WebApiHandler_archive_Args) =>
      RentalManagerUserPropertyArchiveV2WebApiHandler_archive(args.postData, httpClient),
  });
};
